<template>
  <v-dialog v-model="show" max-width="700px">
    <v-card>
      <v-card-title class="headline d-flex align-center justify-space-between">
        <span>{{ texts.settings.users.title }}</span>
        <v-btn icon @click="close">
          <v-icon color="#193D6E">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">{{ texts.settings.users.name }}</th>
              <th class="text-left">{{ texts.settings.users.lastname }}</th>
              <th class="text-left">{{ texts.settings.users.email }}</th>
              <th class="text-left">{{ texts.settings.users.status }}</th>
              <th class="text-center">{{ texts.settings.users.actions }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.sUserId || user.id">
              <td class="text-left">{{ user.sName }}</td>
              <td class="text-left">{{ user.sLastname }}</td>
              <td class="text-left">{{ user.sEmail }}</td>
              <td class="text-left">
                <span>
                  {{
                    user.bActive === true || user.bActive === 1
                      ? texts.settings.users.active
                      : texts.settings.users.inactive
                  }}
                </span>
              </td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="user.bActive ? askDeleteUser(user) : openReactivateForm(user)"
                    >
                      <v-icon :color="user.bActive ? 'red' : 'black'">
                        {{ user.bActive ? 'mdi-delete' : 'mdi-account-check' }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ user.bActive ? texts.settings.users.disableUser : texts.settings.users.reactivateUser }}</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions class="d-flex justify-end" style="padding-bottom: 32px">
        <v-btn
          color="#0075B8"
          elevation="4343"
          class="white--text px-10"
          style="
            border-radius: 36px;
            font-family: 'montserrat-semibold';
            text-transform: none;
            font-size: 16px;
            min-width: 220px;
          "
          @click="openUserForm()"
        >
          {{ texts.settings.users.addUser }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="confirmDeleteDialog" max-width="fit-content">
      <v-card class="pt-5">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <v-img :src="require('@/assets/icons/delete.svg')" style="width: 70px; height: 70px; margin-bottom: -40px;"></v-img>
          <v-card-title class="text-h5 my-4 mt-0 mx-10 pt-10 pb-6 px-8" style="border-radius: 10px; background-color: #E31D1C; color: white; font-family: 'montserrat-semibold' !important;">
            {{ texts.settings.users.confirmDeleteTitle }}
          </v-card-title>
          <v-card-text v-if="!isLoadingOtp" class="mt-4" style="text-align: center; font-family: 'montserrat-semibold'; font-size: 18px;">
            {{ texts.settings.users.confirmDeleteText }}
          </v-card-text>
          <div v-if="isLoadingOtp" style="display: flex; justify-content: center;">
            <v-progress-circular
              indeterminate
              color="amber"
            ></v-progress-circular>
          </div>
        </div>
        <v-card-actions class="pb-4 mt-8" style="justify-content: space-evenly;">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2 px-10"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="isLoadingOtp"
            @click="cancelDelete()"
          >
            {{ texts.settings.users.confirmDeleteCancel }}
          </v-btn>
          <v-btn
            color="red"
            elevation="8"
            class="white--text px-10"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            :disabled="isLoadingOtp"
            @click="startDeleteProcess()"
          >
            {{ texts.settings.users.confirmDeleteDisable }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Two Factor Authentication Dialog for Delete -->
    <v-dialog v-model="otpDeleteDialog" max-width="fit-content" persistent>
      <v-card>
        <v-container class="mt-1">
          <v-card-title class="pa-0 pt-10" style="display: flex; text-align: center; justify-content: center;">
            <span class="title font-weight-bold text-textblack">{{ texts.settings.users.otpTitle }}</span>
          </v-card-title>
          <v-card-text class="py-6 pb-0">
            <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row; width: 600px">
              <div>
                <v-otp-input v-model="otpDelete" length="6" type="number" color="#193D6E"></v-otp-input>
                <p style="font-size: 14px; font-weight: 500;">{{ texts.settings.users.otpDescription }}</p>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="pt-4 pb-4" style="justify-content: space-evenly;">
            <v-btn
              color="#0075B8"
              elevation="8"
              class="mr-2 px-10"
              style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
              outlined
              @click="cancelDelete()"
            >
              {{ texts.settings.users.confirmDeleteCancel }}
            </v-btn>
            <v-btn
              color="#0075B8"
              elevation="8"
              class="white--text px-10"
              style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
              :disabled="otpDelete.length < 6"
              :loading="isLoadingOtp"
              @click="validateDeleteOtp()"
            >
              {{ texts.settings.users.validate }}
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Diálogo para agregar usuario -->
    <v-dialog v-model="userFormDialog" max-width="600px" persistent>
      <v-card>
        <v-stepper v-model="userStep" alt-labels elevation="0">
          <v-stepper-header
            v-if="userStep < 3"
            color="#193D6E"
            class="mt-5 mr-15 ml-15"
            elevation="0"
            style="
              justify-content: center;
              align-items: center;
              box-shadow: none;
            "
          >
            <v-stepper-step
              :complete="userStep > 1"
              step="1"
              color="#193D6E"
            ></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="userStep > 2"
              step="2"
              color="#193D6E"
            ></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1" style="max-width: 600px">
                <v-card-title
                  class="pa-0"
                  style="
                    display: flex;
                    text-align: center;
                    justify-content: center;
                  "
                >
                  <span class="title font-weight-bold text-textblack">
                    {{ editingUser ? "Editar usuario" : "Agregar usuario" }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 px-4">
                  <v-form
                    ref="userForm"
                    v-model="userFormValid"
                    autocomplete="off"
                  >
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="userForm.sName"
                          :label="texts.settings.users.name"
                          :rules="nameRules"
                          style="border-radius: 10px"
                          required
                          outlined
                          hide-details
                        autocomplete="off"
                            name="newUserName"
                        />
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="userForm.sLastname"
                          :label="texts.settings.users.lastname"
                          :rules="lastnameRules"
                          style="border-radius: 10px"
                          required
                          outlined
                          hide-details
                      autocomplete="off"
                          name="newUserLastname"
                        />
                      </v-col>
                      <v-col cols="12" sm="12">
                        <v-text-field
                          v-model="userForm.sEmail"
                          :label="texts.settings.users.email"
                          :rules="emailRules"
                          style="border-radius: 10px"
                          required
                          outlined
                          hide-details
                          autocomplete="off"
                          name="newUserEmail"
                        />
                      </v-col>
                      <v-col cols="12" sm="12">
                        <v-text-field
                          v-model="userForm.sPassword"
                          :label="texts.settings.users.password"
                          style="border-radius: 10px"
                          :rules="passwordRules"
                          :type="showUserPassword ? 'text' : 'password'"
                          required
                          outlined
                          hide-details
                          autocomplete="new-password"
                          name="newUserPassword"
                          :append-icon="
                            showUserPassword ? 'mdi-eye' : 'mdi-eye-off'
                          "
                          @click:append="showUserPassword = !showUserPassword"
                        />
                      </v-col>
                      <v-col cols="12" sm="12">
                        <v-text-field
                          v-model="userForm.sConfirmPassword"
                          :label="texts.settings.users.confirmPassword"
                          style="border-radius: 10px"
                          :rules="confirmPasswordRules"
                          :type="showUserPassword ? 'text' : 'password'"
                          required
                          outlined
                          hide-details
                          autocomplete="new-password"
                          name="newUserConfirmPassword"
                          :append-icon="
                            showUserPassword ? 'mdi-eye' : 'mdi-eye-off'
                          "
                          @click:append="showUserPassword = !showUserPassword"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions
                  class="mt-5"
                  style="justify-content: space-evenly"
                >
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="
                      color: #0075b8;
                      border-radius: 36px;
                      border: 2px solid #0075b8;
                      background-color: #fff;
                      font-family: 'montserrat-semibold';
                      text-transform: none;
                    "
                    outlined
                    @click="closeUserFormDialog"
                  >
                    {{ texts.settings.users.cancel }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="
                      border-radius: 36px;
                      font-family: 'montserrat-semibold';
                      text-transform: none;
                    "
                    :disabled="!isUserFormReady"
                    @click="validateUserFormAndContinue()"
                  >
                    {{ texts.settings.users.continue }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" class="pt-0">
              <v-container class="mt-1" style="max-width: 600px">
                <v-card-title
                  class="pa-0"
                  style="
                    display: flex;
                    text-align: center;
                    justify-content: center;
                  "
                >
                  <span class="title font-weight-bold text-textblack">
                    {{ texts.settings.users.otpTitle }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 pb-0">
                  <div
                    class="pt-4 px-4 mb-4"
                    style="
                      display: flex;
                      justify-content: space-around;
                      flex-direction: row;
                    "
                  >
                    <div>
                      <v-form ref="otpForm" v-model="otpValid">
                        <v-otp-input
                          v-model="otp"
                          :rules="otpRules"
                          type="number"
                          length="6"
                          color="#193D6E"
                        />
                      </v-form>
                      <p style="font-size: 14px; font-weight: 500">
                        {{ texts.settings.users.otpDescription }}
                      </p>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions
                  class="mt-5"
                  style="justify-content: space-evenly"
                >
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="
                      color: #0075b8;
                      border-radius: 36px;
                      border: 2px solid #0075b8;
                      background-color: #fff;
                      font-family: 'montserrat-semibold';
                      text-transform: none;
                    "
                    outlined
                    @click="(userStep = 1), (otp = '')"
                  >
                    {{ texts.settings.users.cancel }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="
                      border-radius: 36px;
                      font-family: 'montserrat-semibold';
                      text-transform: none;
                    "
                    :disabled="!otpValid"
                    @click="validateUserOtp()"
                    :loading="isLoadingOtp"
                  >
                    {{ texts.settings.users.validate }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>

    <!-- Diálogo para reactivar usuario -->
    <v-dialog v-model="reactivateFormDialog" max-width="600px" persistent>
      <v-card>
        <v-stepper v-model="reactivateStep" alt-labels elevation="0">
          <v-stepper-header
            v-if="reactivateStep < 3"
            color="#193D6E"
            class="mt-5 mr-15 ml-15"
            elevation="0"
            style="justify-content: center; align-items: center; box-shadow: none;"
          >
            <v-stepper-step
              :complete="reactivateStep > 1"
              step="1"
              color="#193D6E"
            ></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="reactivateStep > 2"
              step="2"
              color="#193D6E"
            ></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1" style="max-width: 600px">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center;">
                  <span class="title font-weight-bold text-textblack">
                    {{ texts.settings.users.reactivateUser }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 px-4">
                  <v-form ref="reactivateForm" v-model="reactivateFormValid" autocomplete="off">
                    <v-row>
                      <v-col cols="12" sm="12">
                        <v-text-field
                          v-model="reactivateForm.sEmail"
                          :label="texts.settings.users.email"
                          style="border-radius: 10px"
                          disabled
                          outlined
                          hide-details
                          autocomplete="off"
                        />
                      </v-col>
                      <v-col cols="12" sm="12">
                        <v-text-field
                          v-model="reactivateForm.sPassword"
                          :label="texts.settings.users.password"
                          style="border-radius: 10px"
                          :rules="passwordRules"
                          :type="showReactivatePassword ? 'text' : 'password'"
                          required
                          outlined
                          hide-details
                          autocomplete="new-password"
                          :append-icon="showReactivatePassword ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="showReactivatePassword = !showReactivatePassword"
                        />
                      </v-col>
                      <v-col cols="12" sm="12">
                        <v-text-field
                          v-model="reactivateForm.sConfirmPassword"
                          :label="texts.settings.users.confirmPassword"
                          style="border-radius: 10px"
                          :rules="confirmPasswordRules"
                          :type="showReactivatePassword ? 'text' : 'password'"
                          required
                          outlined
                          hide-details
                          autocomplete="new-password"
                          :append-icon="showReactivatePassword ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="showReactivatePassword = !showReactivatePassword"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: #0075b8; border-radius: 36px; border: 2px solid #0075b8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="closeReactivateForm"
                  >
                    {{ texts.settings.users.cancel }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :disabled="!isReactivateFormReady"
                    @click="validateReactivateFormAndContinue"
                  >
                    {{ texts.settings.users.continue }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" class="pt-0">
              <v-container class="mt-1" style="max-width: 600px">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center;">
                  <span class="title font-weight-bold text-textblack">
                    {{ texts.settings.users.otpTitle }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 pb-0">
                  <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row;">
                    <div>
                      <v-form ref="reactivateOtpForm" v-model="reactivateOtpValid">
                        <v-otp-input
                          v-model="reactivateOtp"
                          :rules="otpRules"
                          type="number"
                          length="6"
                          color="#193D6E"
                        />
                      </v-form>
                      <p style="font-size: 14px; font-weight: 500">
                        {{ texts.settings.users.otpDescription }}
                      </p>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: #0075b8; border-radius: 36px; border: 2px solid #0075b8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="(reactivateStep = 1), (reactivateOtp = '')"
                  >
                    {{ texts.settings.users.cancel }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :disabled="!reactivateOtpValid"
                    @click="validateReactivateOtp"
                    :loading="isLoadingOtp"
                  >
                    {{ texts.settings.users.validate }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogUsers",
  props: {
    value: Boolean,
    users: {
      type: Array,
      default: () => []
    },
    texts: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      confirmDeleteDialog: false,
      otpDeleteDialog: false,
      userToDelete: null,
      userFormDialog: false,
      reactivateFormDialog: false,
      reactivateStep: 1,
      userStep: 1,
      userForm: {
        sName: "",
        sLastname: "",
        sEmail: "",
        sPassword: "",
        sConfirmPassword: ""
      },
      reactivateForm: {
        sUserId: "",
        sEmail: "",
        sPassword: "",
        sConfirmPassword: ""
      },
      reactivateFormValid: false,
      reactivateOtpValid: false,
      reactivateOtp: "",
      showReactivatePassword: false,
      userFormValid: false,
      showUserPassword: false,
      otp: "",
      otpValid: false,
      otpDelete: "",
      otpDeleteValid: false,
      isLoadingOtp: false,
      editingUser: false
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    nameRules() {
      return [(v) => !!v || this.texts.settings.users.nameRequired];
    },
    lastnameRules() {
      return [(v) => !!v || this.texts.settings.users.lastnameRequired];
    },
    emailRules() {
      return [
        (v) => !!v || this.texts.settings.users.emailRequired,
        (v) => /.+@.+\..+/.test(v) || this.texts.settings.users.emailValid
      ];
    },
    passwordRules() {
      return [
        (v) => !!v || this.texts.settings.users.passwordRequired,
        (v) => v.length >= 6 || this.texts.settings.users.passwordLength,
        (v) =>
          /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/.test(v) ||
          this.texts.settings.users.passwordSpecialCharacters
      ];
    },
    otpRules() {
      return [
        (v) => !!v || this.texts.settings.users.otpRequired,
        (v) => v.length === 6 || this.texts.settings.users.otpLength
      ];
    },
    confirmPasswordRules() {
      return [
        (v) => !!v || this.texts.settings.users.confirmPasswordRequired,
        (v) => {
          const form = this.userFormDialog ? this.userForm : this.reactivateForm;
          return v === form.sPassword || this.texts.settings.users.confirmPasswordMatch;
        }
      ];
    },
    isUserFormReady() {
      if (this.userStep === 1) {
        return this.userFormValid;
      } else if (this.userStep === 2) {
        return this.otpValid;
      }
      return false;
    },
    isReactivateFormReady() {
      if (this.reactivateStep === 1) {
        return this.reactivateFormValid;
      } else if (this.reactivateStep === 2) {
        return this.reactivateOtpValid;
      }
      return false;
    }
  },
  watch: {
    "userForm.sPassword"() {
      this.$nextTick(() => {
        if (this.$refs.userForm) {
          this.$refs.userForm.validate();
        }
      });
    },
    "userForm.sConfirmPassword"() {
      this.$nextTick(() => {
        if (this.$refs.userForm) {
          this.$refs.userForm.validate();
        }
      });
    },
    "reactivateForm.sPassword"() {
      this.$nextTick(() => {
        if (this.$refs.reactivateForm) {
          this.$refs.reactivateForm.validate();
        }
      });
    },
    "reactivateForm.sConfirmPassword"() {
      this.$nextTick(() => {
        if (this.$refs.reactivateForm) {
          this.$refs.reactivateForm.validate();
        }
      });
    }
  },
  methods: {
    close() {
      this.show = false;
    },
    askDeleteUser(user) {
      this.userToDelete = user;
      this.confirmDeleteDialog = true;
    },
    cancelDelete() {
      this.confirmDeleteDialog = false;
      this.otpDeleteDialog = false;
      this.userToDelete = null;
      this.otpDelete = "";
      this.otpDeleteValid = false;
      this.isLoadingOtp = false;
    },
    startDeleteProcess() {
      this.confirmDeleteDialog = false;
      this.otpDeleteDialog = true;
      this.sendOtp();
    },
    validateDeleteOtp() {
      this.isLoadingOtp = true;
      const payloadOtp = { sCode: this.otpDelete };
      DB.post(
        `${URI}/api/v1/${this.$store.state.language}/authenticator/verify`,
        payloadOtp,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.success) {
            this.$parent.mixError(response.data.message, response.status);
          } else {
            this.otpDeleteDialog = false;
            const user = this.userToDelete;
            this.userToDelete = null;
            this.$nextTick(() => {
              this.$emit("delete-user", user);
            });
          }
        })
        .catch((error) => {
          this.$parent.mixError(
            error.response.data.message,
            error.response.status
          );
        })
        .finally(() => {
          this.isLoadingOtp = false;
        });
    },
    closeUserFormDialog() {
      this.userFormDialog = false;
      this.userStep = 1;
      this.otp = "";
      this.resetUserForm();
    },
    resetUserForm() {
      this.userForm = {
        sName: "",
        sLastname: "",
        sEmail: "",
        sPassword: "",
        sConfirmPassword: ""
      };
      this.userFormValid = false;
      this.otpValid = false;
      if (this.$refs.userForm) {
        this.$refs.userForm.resetValidation();
      }
    },
    validateUserFormAndContinue() {
      // Verificar que el formulario sea válido antes de continuar
      if (this.$refs.userForm && this.$refs.userForm.validate()) {
        this.userStep = 2;
      }
      this.sendOtp();
    },
    sendOtp() {
      DB.get(`${URI}/api/v1/${this.$store.state.language}/authenticator/`,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.success) {
            this.$parent.mixError(response.data.message, response.status);
          }
        })
        .catch((error) => {
          this.$parent.mixError(
            error.response.data.message,
            error.response.status
          );
        });
    },
    validateUserOtp() {
      this.isLoadingOtp = true;
      const payloadOtp = { sCode: this.otp };
      DB.post(
        `${URI}/api/v1/${this.$store.state.language}/authenticator/verify`,
        payloadOtp,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.success) {
            this.$parent.mixError(response.data.message, response.status);
          } else {
            this.userFormDialog = false;
            this.$emit("user-created", this.userForm);
            this.resetUserForm();
            this.userStep = 1;
            this.otp = "";
            this.$emit("refresh-users");
          }
        })
        .catch((error) => {
          this.$parent.mixError(
            error.response.data.message,
            error.response.status
          );
        })
        .finally(() => {
          this.isLoadingOtp = false;
        });
    },
    openUserForm() {
      this.resetUserForm();
      this.userFormDialog = true;
    },
    openReactivateForm(user) {
      this.reactivateForm = {
        sUserId: user.sUserId || user.id,
        sEmail: user.sEmail,
        sPassword: "",
        sConfirmPassword: ""
      };
      this.reactivateStep = 1;
      this.reactivateFormDialog = true;
    },
    closeReactivateForm() {
      this.reactivateFormDialog = false;
      this.reactivateStep = 1;
      this.reactivateOtp = "";
      this.resetReactivateForm();
    },
    validateReactivateFormAndContinue() {
      if (this.$refs.reactivateForm && this.$refs.reactivateForm.validate()) {
        this.reactivateStep = 2;
        this.sendOtp();
      }
    },
    validateReactivateOtp() {
      this.isLoadingOtp = true;
      const payloadOtp = { sCode: this.reactivateOtp };
      DB.post(
        `${URI}/api/v1/${this.$store.state.language}/authenticator/verify`,
        payloadOtp,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.success) {
            this.$parent.mixError(response.data.message, response.status);
          } else {
            const payload = {
              sUserId: this.reactivateForm.sUserId,
              sPassword: this.reactivateForm.sPassword
            };
            
            return DB.patch(
              `${URI}/api/v1/${this.$store.state.language}/users/activate`,
              payload,
              {
                headers: {
                  Authorization: this.$store.state.sToken
                    ? `Bearer ${this.$store.state.sToken}`
                    : ""
                }
              }
            );
          }
        })
        .then((response) => {
          if (response && !response.data.success) {
            this.$parent.mixError(response.data.message, response.status);
          } else if (response) {
            this.reactivateFormDialog = false;
            this.$emit("user-reactivated", this.reactivateForm.sUserId);
            this.resetReactivateForm();
            this.reactivateStep = 1;
            this.reactivateOtp = "";
            this.$emit("refresh-users");
          }
        })
        .catch((error) => {
          this.$parent.mixError(
            error.response.data.message,
            error.response.status
          );
        })
        .finally(() => {
          this.isLoadingOtp = false;
        });
    },
    resetReactivateForm() {
      this.reactivateForm = {
        sUserId: "",
        sEmail: "",
        sPassword: "",
        sConfirmPassword: ""
      };
      this.reactivateFormValid = false;
      this.reactivateOtpValid = false;
      if (this.$refs.reactivateForm) {
        this.$refs.reactivateForm.resetValidation();
      }
    },
  }
};
</script>
